import LanguagesApi from '../../../core/api/LanguagesApi'
export const FETCHING_LANGUAGES = 'FETCHING_LANGUAGES'
export const FETCH_LANGUAGES = 'FETCH_LANGUAGES'

export const fetchingLanguages = service => ({
  type: FETCHING_LANGUAGES
})

export function fetchLanguages () {
  const api = new LanguagesApi()

  return async (dispatch) => {
    try {
      const response = await api.fetchingLanguages()
      dispatch({
        type: FETCH_LANGUAGES,
        payload: response
      })
      return response
    } catch (error) {
      dispatch({
        type: FETCH_LANGUAGES,
        payload: []
      })
      throw error
    }
  }
}
